import React, { useEffect, createRef } from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

const StravaActivitiesHeader = (props) => {
  return (
    <>
      <div className="page-header page-header-small">
        <div
          className="page-header-image"
          style={{
            backgroundImage:
              "url(" +
              require("../../assets/img/pexels-daniel-reche-3601094.jpg")
                .default +
              ")",
          }}
        ></div>
        <div className="content-center">
          <Row>
            <Col className="ml-auto mr-auto" md="8">
              <h1 className="title"></h1>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default StravaActivitiesHeader;
